import React, { useState } from 'react';
import {
  Section,
  Option,
  RangeInput,
} from 'components/PropertyEditor';
import { TextInput } from "components/PropertyEditor/PropertyEditor";
import { motion } from "framer-motion";

/**
 * Validate the inputs for the component
 * @type {{update: (shim|(function(*, *, *, *, *, *): (undefined))), loading: {new(...args: A): R} | ((...args: A) => R) | OmitThisParameter<T> | T | any | {new(...args: AX[]): R} | ((...args: AX[]) => R), element}}
 * @private
 */
// const _props = {
//   element: PropTypes.shape({
//     action: PropTypes.string,
//     actionArg: PropTypes.any
//   }),
//   update: PropTypes.func.isRequired,
// };

/**
 * The editable properties of an element that can be moved on
 * the canvas
 * @param element
 * @param update
 * @param loading
 * @returns {*}
 * @constructor
 */
const PositionableElementProperties = ({ tabAnimation, element, update }) => {

  return (
    <motion.div {...tabAnimation}>
      <Section>
        <Name value={element.name} update={update} />
        {
          (element.__typename !== 'TriggerElement' && <>
            <PosY key={"posY_" + element.id} value={element.posY} maxValue={405} update={update} />
            <PosX key={"posX_" + element.id} value={element.posX} maxValue={720} update={update} />
            <Height key={"height_" + element.id} value={element.height} maxValue={405} update={update} />
            <Width key={"width_" + element.id} value={element.width} maxValue={720} update={update} />
          </>)
        }
      </Section>
    </motion.div>
  );
};
//PositionableElementProperties.propTypes = _props;
export default PositionableElementProperties;

const Name = ({ value, update }) => {
  const [val, setVal] = useState(value);

  return (
    <Option
      label="Name"
      value={val}
      Component={TextInput}
      onChange={val => setVal(val)}
      onBlur={val => update("name", val)}
    />
  )
};

const PosX = ({ value, maxValue, update, key }) => {
  const [val, setVal] = useState(value);
  return (
    <Option
      label="Horizontal Position (px)"
      value={val}
      Component={RangeInput}
      onAfterChange={val => update("posX", val)}
      onChange={val => { setVal(val); update("posX", val) }}
      max={maxValue}
      key={key}
    />
  )
};

const PosY = ({ value, maxValue, update, key }) => {
  const [val, setVal] = useState(value);

  return (
    <Option
      key={key}
      label="Vertical Position (px)"
      value={val}
      Component={RangeInput}
      onAfterChange={val => update("posY", val)}
      onChange={val => { setVal(val); update("posY", val); }}
      max={maxValue}
    />
  )
};

const Height = ({ value, maxValue, update, key }) => {
  const [val, setVal] = useState(value);
  
  return (
    <Option
      key={key}
      label="Height (px)"
      value={val}
      Component={RangeInput}
      onAfterChange={val => update("height", val)}
      onChange={val => { setVal(val); update("height", val); }}
      max={maxValue}
    />
  )
};

const Width = ({ value, maxValue, update, key }) => {
  const [val, setVal] = useState(value);

  return (
    <Option
      key={key}
      label="Width (px)"
      value={val}
      Component={RangeInput}
      onAfterChange={val => update("width", val)}
      onChange={val => { setVal(val); update("width", val); }}
      max={maxValue}
    />
  )
};